module.exports = __webpack_public_path__ + "img/incomplete_right.6082bc3b.jpg";